/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%]{margin-right:3px;height:22px;padding:0 2px;display:inline!important}button[hidden][_ngcontent-%COMP%]{display:none!important}div.tags[_ngcontent-%COMP%]{margin-bottom:5px}div.tags[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{font-size:90%}div.tags[_ngcontent-%COMP%]   .fa-times[_ngcontent-%COMP%]{margin-left:10px}"];
export { styles as styles };
